import { AxiosResponse } from 'axios';
import { hardReload } from '@/core/navigation/redirect.service';
import log from '@/core/logging.service';

let previousVersionB2C;
let previousVersionB2B;

const responseHandler = async(response: AxiosResponse) => {
    const currentVersionB2C: string | undefined = response.headers['b2c-api-version'];
    const currentVersionB2B: string | undefined = response.headers['b2b-api-version'];

    const isFirstTimeB2C = !previousVersionB2C && currentVersionB2C;
    const isFirstTimeB2B = !previousVersionB2B && currentVersionB2B;

    if (isFirstTimeB2C) {
        previousVersionB2C = currentVersionB2C;
    }
    if (isFirstTimeB2B) {
        previousVersionB2B = currentVersionB2B;
    }

    const isVersionMismatchB2C = currentVersionB2C && previousVersionB2C && currentVersionB2C !== previousVersionB2C;
    const isVersionMismatchB2B = currentVersionB2B && previousVersionB2B && currentVersionB2B !== previousVersionB2B;

    if (isVersionMismatchB2C || isVersionMismatchB2B) {
        log.info(`Reloading SPA due to api-version mismatch. PreviousB2C: ${previousVersionB2C}, CurrentB2C: ${currentVersionB2C}. PreviousB2B: ${previousVersionB2B}, CurrentB2B: ${currentVersionB2B}`);
        hardReload();
    }

    return response;
};

export {
    responseHandler,
};
